import { Component, OnInit, ViewChild } from '@angular/core';
import {FormControl} from '@angular/forms';
import {MatPaginator, MatSort, MatTableDataSource} from '@angular/material';
import {MatSnackBar} from '@angular/material/snack-bar';
import { ViewobserverService } from '../service/viewobserver.service';
import { AlarmsqueryService } from '../service/alarmsquery.service';
import { merge } from 'rxjs/operators';
import { Options } from 'selenium-webdriver/edge';
//import { text } from '@angular/core/src/render3';
import { months } from 'moment';

export interface Alarms {
  timestamp?: string;
  value?: string;
  desc?: string;
  type?: string;
  zona?: string;
  city?: string;
  office?: string;
  device?: string;
  usr?: string;
}

//const ELEMENT_DATA: PeriodicElement[] = [];

  /*
  {timestamp: '2019/28/2 - 8:30', value: '21.30', desc: 'Corriente Sobrepasa Rango Normalidad', type: 'Baja', zona: 'Sierra', city: 'Quito', office: 'Iñaquito', device: 'PM TEP'},
  {timestamp: '2019/28/2 - 8:35', value: '22.00', desc: 'Corriente Sobrepasa Rango Normalidad', type: 'Baja', zona: 'Sierra', city: 'Quito', office: 'Iñaquito', device: 'PM TEP'},
  {timestamp: '2019/28/2 - 8:36', value: '20.10', desc: 'Corriente Sobrepasa Rango Normalidad', type: 'Baja', zona: 'Sierra', city: 'Quito', office: 'Iñaquito', device: 'PM TEP'},
  {timestamp: '2019/27/2 - 14:37', value: '21.80', desc: 'Corriente Sobrepasa Rango Normalidad', type: 'Baja', zona: 'Sierra', city: 'Quito', office: 'Iñaquito', device: 'PM TEP'},
  {timestamp: '2019/25/2 - 12:20', value: '25.10', desc: 'Corriente Sobrepasa Rango Normalidad', type: 'Baja', zona: 'Sierra', city: 'Quito', office: 'Iñaquito', device: 'PM TEP'},
  {timestamp: '2019/25/2 - 13:50', value: '22.30', desc: 'Corriente Sobrepasa Rango Normalidad', type: 'Baja', zona: 'Sierra', city: 'Quito', office: 'Iñaquito', device: 'PM TEP'},
  {timestamp: '2019/25/2 - 15:45', value: '21.10', desc: 'Corriente Sobrepasa Rango Normalidad', type: 'Baja', zona: 'Sierra', city: 'Quito', office: 'Iñaquito', device: 'PM TEP'},
  {timestamp: '2019/25/2 - 12:40', value: '19.10', desc: 'Corriente Sobrepasa Rango Normalidad', type: 'Baja', zona: 'Sierra', city: 'Quito', office: 'Iñaquito', device: 'PM TEP'},
  {timestamp: '2019/22/2 - 14:30', value: '28.10', desc: 'Corriente Sobrepasa Rango Normalidad', type: 'Baja', zona: 'Sierra', city: 'Quito', office: 'Iñaquito', device: 'PM TEP'},
  {timestamp: '2019/22/2 - 10:20', value: '0', desc: 'Voltaje de Fase en Cero Voltios', type: 'Alta', zona: 'Sierra', city: 'Ambato', office: 'Centro', device: 'PM TEP'},
  {timestamp: '2019/21/2 - 11:10', value: '0', desc: 'Voltaje de Fase en Cero Voltios', type: 'Alta', zona: 'Sierra', city: 'Cuenca', office: 'El Vergel', device: 'PM T2'},
  {timestamp: '2019/21/2 - 9:34', value: '0', desc: 'Voltaje de Fase en Cero Voltios', type: 'Alta', zona: 'Sierra', city: 'Cuenca', office: 'Aeropuerto', device: 'PM T1'},
  {timestamp: '2019/20/2 - 4:34', value: '31', desc: 'Temperatura Excede Limite Superior', type: 'Alta', zona: 'Costa', city: 'Guayaquil', office: 'Aeropuerto', device: 'MT2'},
  {timestamp: '2019/25/2 - 10:20', value: '0', desc: 'Voltaje de Fase en Cero Voltios', type: 'Alta', zona: 'Sierra', city: 'Ambato', office: 'Centro', device: 'PM TEP'},
  {timestamp: '2019/27/2 - 11:10', value: '0', desc: 'Voltaje de Fase en Cero Voltios', type: 'Alta', zona: 'Sierra', city: 'Cuenca', office: 'El Vergel', device: 'PM T2'},
  {timestamp: '2019/28/2 - 9:34', value: '0', desc: 'Voltaje de Fase en Cero Voltios', type: 'Alta', zona: 'Sierra', city: 'Cuenca', office: 'Aeropuerto', device: 'PM T1'},
  {timestamp: '2019/1/3 - 4:34', value: '31', desc: 'Temperatura Excede Limite Superior', type: 'Alta', zona: 'Costa', city: 'Guayaquil', office: 'Aeropuerto', device: 'MT2'}
*/

@Component({
  selector: 'app-alarms',
  templateUrl: './alarms.component.html',
  styleUrls: ['./alarms.component.css']
})

export class AlarmsComponent implements OnInit {
  isMobile: boolean = false;
  displayedColumns: string[] = ['timestamp', 'value', 'desc', 'type', 'zona', 'city', 'office', 'device', 'usr'];
  alarms: Alarms[] = [];
  dataSource = new MatTableDataSource(this.alarms);
  date1 = new FormControl();
  date2 = new FormControl();
  maxDate = new Date(); //today
  dummy = new Date(); //buffer date
  minDate = new Date(this.dummy.setFullYear(this.dummy.getFullYear() - 1)); //one year back

  
  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
    console.log(this.minDate);
    if (this.dataSource.paginator){
      this.dataSource.paginator.firstPage();
    }
  }

  searchBD(time1, time2){
    if (time1 == null || time2 == null)
      { 
        this.snackBar.open('Debe seleccionar fecha de inicio y fin!', 'x', {duration: 3500, verticalPosition: 'top'}); 
      }
      else
      {
        let start = time1.getFullYear() + '-' + ( '0' + (time1.getMonth()+1)).slice(-2) + '-' + ('0' + (time1.getDate()-1)).slice(-2) + 'T23:59:00.000Z';
        
        let end = time2.getFullYear() + '-' + ( '0' + (time2.getMonth()+1)).slice(-2) + '-' + ('0' + time2.getDate()).slice(-2) + 'T23:59:00.000Z';
        
        console.log(start, end);
        if (start > end)
        {
          this.snackBar.open('Fecha de inicio no puede ser mayor a fecha de fin', 'x', {duration: 3500, verticalPosition: 'top'}); 
        }
        else
        {
          this.alarmService.getAlarmsByTime(start, end).subscribe(alarms =>{
          console.log(alarms);
          this.alarms = alarms;
          this.dataSource = new MatTableDataSource(alarms);
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
          });
        }
      }
  }

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(private viewObserver: ViewobserverService,
    private alarmService: AlarmsqueryService,
    private snackBar: MatSnackBar) { }

  ngOnInit() {    
    this.alarmService.getAlarms().subscribe(alarms =>{
      //console.log(alarms);
      this.alarms = alarms;
      this.dataSource = new MatTableDataSource(alarms);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    });
    this.viewObserver.getMode().subscribe(result =>{
      this.isMobile = result.matches;
      if (this.isMobile){
        this.displayedColumns = ['timestamp', 'desc', 'type', 'city', 'office', 'device'];
      }else{
        this.displayedColumns = ['timestamp', 'value', 'desc', 'type', 'zona', 'city', 'office', 'device', 'usr'];
      }
    })
  }

  openDatePicker(dp) {
    dp.open();
  }

  downloadFile(data: any) {
    const replacer = (key, value) => value === null ? '-' : value; // specify how you want to handle null values here
    const header = Object.keys(data[0]);
    let csv = data.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','));
    csv.unshift(header.join(','));
    csv[0] = this.displayedColumns
    let csvArray = csv.join('\r\n');
    
    
    var a = document.createElement('a');
    var blob = new Blob([csvArray], {type: 'text/csv' }),
    url = window.URL.createObjectURL(blob);

    //var startDate = this.date1.value.getFullYear() + '-' + ( '0' + (this.date1.value.getMonth()+1)).slice(-2) + '-' + ('0' + this.date1.value.getDate()).slice(-2) + ' 00:00:00';
            
    //var endDate = this.date2.value.getFullYear() + '-' + ( '0' + (this.date2.value.getMonth()+1)).slice(-2) + '-' + ('0' + this.date2.value.getDate()).slice(-2) + ' 23:59:00';


    a.href = url;
    a.download = "Consutlta-Alarmas.csv";
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
    
}

}
